import {Link} from "react-router-dom";
import "./NavBar.scss";
import {PureComponent} from "react";


export default class NavBar extends PureComponent {
    render() {
        return (
            <nav className="upwire-navbar" role="navigation" aria-label="main navigation">
                <Link to="/">
                    <img className="navbar-logo" src="/images/upwire-logo.png" alt="Upwire"/>
                </Link>
            </nav>
        );
    }
}

